import styled from 'styled-components'

export {
	StyledClassroomCard as StyledCourseCard,
	StyledClassroomImage as StyledCourseImage,
	Badge,
	CardBody,
	Title,
	Instructor,
	InfoWrapper,
	GradeWrapper,
	Grade,
	SubjectWrapper,
	SubjectImage,
	Subject,
	CardButton,
} from '@Components/Cards/ClassroomCard/ClassroomCard.styled'

export const PriceRibbon = styled.div`
	position: absolute;
	left: 0;
	top: 20px;
	padding: 4px 13px 4px 8px;
	background-color: ${props => props.theme.colors.primary};
	color: white;
	border-radius: 0 10px 10px 0;
	font-size: 14px;
	font-weight: bold;
	display: flex;
	align-items: center;
	gap: 6px;
`

export const OldPrice = styled.span`
	font-size: 11px;
	font-weight: normal;
	text-decoration: line-through;
	opacity: 0.8;
`

export const BundleChipsRow = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 4px;
	margin-top: 6px;
`

export const BundleChip = styled.span`
	font-size: 10px;
	font-weight: 600;
	border-radius: 999px;
	padding: 2px 8px;
	background: #f0eefc;
	color: ${props => props.theme.colors.primary};
	cursor: pointer;
	&:hover {
		text-decoration: underline;
	}
`
